<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="4" v-for="(emprendedor, index) in emprendedores" :key="index" class="mb-5 d-flex">
        <v-card v-show="emprendedor.visible"
          class="mx-auto entrepreneur-card entrepreneur-card--clickable d-flex flex-column" max-width="800"
          elevation="4" @click="openProfile(emprendedor)">
          <v-avatar style="
                position: relative;
                top: -30px;
                left: -10px;
                box-shadow: rgba(0, 0, 0, 0.5) 0px 3px 18px;
              " width="80px" class="pa-1" height="80px" color="grey lighten-3">

            <img :src="resolveLogoSrc(emprendedor.logo)" alt="Logo" style="object-fit: scale-down" />
          </v-avatar>

          <div class="d-flex flex-column align-center mt-n12">
            <div
              v-if="isFeaturedList"
              class="entrepreneur-card__badge"
            >
              Destacada
            </div>

            <v-card-title class="custom-title text-center" style="word-break: break-word;">
              {{ emprendedor.business_name.toUpperCase() }}
            </v-card-title>

            <v-card-subtitle class="custom-subtitle text-center grey--text">
              {{ emprendedor.category }}
            </v-card-subtitle>
          </div>


          <div class="entrepreneur-card__body flex-grow-1 d-flex flex-column">
            <v-carousel class="product-carousel" height="260" show-arrows-on-hover hide-delimiters>
              <v-carousel-item v-for="(image, imageIndex) in emprendedor.photos" :key="imageIndex">
                <v-img height="260" :src="resolvePhotoSrc(image)" aspect-ratio="1"
                  class="grey lighten-2 product-carousel__image" :alt="`Producto de ${emprendedor.business_name}`"
                  @click.stop="openProfile(emprendedor)">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-1" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-carousel-item>
            </v-carousel>

            <v-card-text class="custom-description text--primary">
              <div v-if="
                emprendedor.description.length > 100 &&
                emprendedor.showMore == false
              ">
                {{ emprendedor.description.substring(0, 100) }}
                <v-btn plain small class="text-capitalize" @click.stop="emprendedor.showMore = true">
                  ver más...
                </v-btn>
              </div>
              <div v-else>{{ emprendedor.description }}</div>
            </v-card-text>
          </div>

          <div class="d-flex flex-column align-center mt-auto">

            <v-col cols="10" class="text-center">
              <span itemprop="author" itemscope itemtype="https://schema.org/Person">
                <v-btn color="primary" elevation="2" icon :href="resolveWebsiteHref(emprendedor.web)" target="_blank"
                  v-show="hasWebsite(emprendedor.web)" @click.stop="trackContactClick(emprendedor, 'web')">
                  <v-icon color="light blue">fa-globe</v-icon>
                </v-btn>
              </span>

              <v-btn color="primary" elevation="2" icon :href="resolveMailTo(emprendedor.email)" target="_blank"
                v-show="hasEmail(emprendedor.email)" @click.stop="trackContactClick(emprendedor, 'email')">
                <v-icon color="#dd4b39">fa-envelope</v-icon>
              </v-btn>

              <v-btn color="primary" elevation="2" icon :href="resolveWhatsApp(emprendedor.phone)" target="_blank"
                v-show="hasPhone(emprendedor.phone)" @click.stop="trackContactClick(emprendedor, 'whatsapp')">
                <v-icon color="#25d366">fa-whatsapp</v-icon>
              </v-btn>

              <v-btn color="primary" elevation="2" icon :href="resolveInstagramHref(emprendedor.instagram)"
                target="_blank" v-show="hasInstagram(emprendedor.instagram)" @click.stop="trackContactClick(emprendedor, 'instagram')">
                <v-icon color="#ac2bac">fa-instagram</v-icon>
              </v-btn>

              <v-btn color="primary" elevation="2" icon :href="resolveFacebookHref(emprendedor.facebook)"
                target="_blank" v-show="hasFacebook(emprendedor.facebook)" @click.stop="trackContactClick(emprendedor, 'facebook')">
                <v-icon color="#3b5998">fa-facebook</v-icon>
              </v-btn>
            </v-col>
          </div>

        </v-card>
      </v-col>

      <div ref="endOfPage"></div>
    </v-row>

    <v-dialog v-if="dialog" v-model="dialog" width="500">
      <v-img :src="resolvePhotoSrc(selectedImage)" aspect-ratio="1" class="grey lighten-2">
      </v-img>
    </v-dialog>

    <v-dialog v-model="profileDialog" max-width="960px" scrollable>
      <v-card v-if="selectedEntrepreneur" class="profile-dialog">
        <v-card-title class="d-flex align-center">
          <div class="d-flex align-center">
            <v-avatar size="64" class="mr-4" color="grey lighten-3">
              <img :src="resolveLogoSrc(selectedEntrepreneur.logo)" alt="Logo" style="object-fit: contain" />
            </v-avatar>
            <div>
              <div class="profile-dialog__title">
                {{ selectedEntrepreneur.business_name.toUpperCase() }}
              </div>
              <div class="profile-dialog__subtitle">
                {{ selectedEntrepreneur.category }}
              </div>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon class="profile-dialog__close-btn" aria-label="Cerrar perfil" @click="closeProfile">
            <v-icon class="profile-dialog__close-icon">fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <p class="profile-dialog__description">
                {{ selectedEntrepreneur.description }}
              </p>
              <p v-if="selectedEntrepreneur.ownerName" class="profile-dialog__owner">
                <strong>Emprendedor(a):</strong> {{ selectedEntrepreneur.ownerName }}
              </p>
              <p v-if="selectedEntrepreneur.commercialOffer" class="profile-dialog__offer">
                <strong>Oferta:</strong> {{ selectedEntrepreneur.commercialOffer }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-carousel v-if="selectedEntrepreneur.photos && selectedEntrepreneur.photos.length"
                class="profile-dialog__carousel product-carousel product-carousel--dialog" height="320" hide-delimiters
                show-arrows-on-hover>
                <v-carousel-item v-for="(photo, idx) in selectedEntrepreneur.photos" :key="idx">
                  <v-img height="320" :src="resolvePhotoSrc(photo)" aspect-ratio="1"
                    class="grey lighten-2 profile-dialog__image"
                    :alt="`Producto de ${selectedEntrepreneur.business_name}`">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-1" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-carousel-item>
              </v-carousel>
              <div v-else class="profile-dialog__empty">
                Sin imágenes disponibles
              </div>
            </v-col>
          </v-row>
          <div class="profile-dialog__contact">
            <span class="profile-dialog__contact-label">Contacto</span>
            <div class="profile-dialog__contact-actions">
              <v-btn v-if="hasWebsite(selectedEntrepreneur.web)" icon color="primary"
                :href="resolveWebsiteHref(selectedEntrepreneur.web)" target="_blank"
                @click="trackContactClick(selectedEntrepreneur, 'web')">
                <v-icon color="light blue">fa-globe</v-icon>
              </v-btn>
              <v-btn v-if="hasEmail(selectedEntrepreneur.email)" icon color="primary"
                :href="resolveMailTo(selectedEntrepreneur.email)" target="_blank"
                @click="trackContactClick(selectedEntrepreneur, 'email')">
                <v-icon color="#dd4b39">fa-envelope</v-icon>
              </v-btn>
              <v-btn v-if="hasPhone(selectedEntrepreneur.phone)" icon color="primary"
                :href="resolveWhatsApp(selectedEntrepreneur.phone)" target="_blank"
                @click="trackContactClick(selectedEntrepreneur, 'whatsapp')">
                <v-icon color="#25d366">fa-whatsapp</v-icon>
              </v-btn>
              <v-btn v-if="hasInstagram(selectedEntrepreneur.instagram)" icon color="primary"
                :href="resolveInstagramHref(selectedEntrepreneur.instagram)" target="_blank"
                @click="trackContactClick(selectedEntrepreneur, 'instagram')">
                <v-icon color="#ac2bac">fa-instagram</v-icon>
              </v-btn>
              <v-btn v-if="hasFacebook(selectedEntrepreneur.facebook)" icon color="primary"
                :href="resolveFacebookHref(selectedEntrepreneur.facebook)" target="_blank"
                @click="trackContactClick(selectedEntrepreneur, 'facebook')">
                <v-icon color="#3b5998">fa-facebook</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="loading" top>
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" location="center">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { EventBus } from "../main";
import {
  ASSET_BASE_URL,
  CATALOG_CATEGORY_OPTIONS,
  CATALOG_OCCASIONS_PATH,
  CATALOG_OCCASIONS_URL,
  CATALOG_POSTULATIONS_PATH,
  CATALOG_POSTULATIONS_URL,
} from "../config/catalog";

const STANDARD_CATEGORIES = CATALOG_CATEGORY_OPTIONS.filter(
  (category) => category !== "Otros"
);

const DEFAULT_DESCRIPTION = "Sin descripción disponible.";
const SEARCH_PARAM_OCCASION = "ocasion";
const SEARCH_PARAM_QUERY = "q";
const SEARCH_PARAM_CATEGORY = "categoria";
const SEARCH_PARAM_REGION = "region";
const OCCASION_ALIASES = {
  dia_de_la_madre: "dia_de_las_madres",
  corporativo: "regalos_corporativos",
  regalos_coorporativos: "regalos_corporativos",
};

const normalizeText = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value).trim();
};

const normalizeArray = (value) => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.map((item) => normalizeText(item)).filter(Boolean);
};

const firstNonEmptyValue = (...values) => {
  for (const value of values) {
    const normalizedValue = normalizeText(value);

    if (normalizedValue) {
      return normalizedValue;
    }
  }

  return "";
};

const slugifyValue = (value) =>
  normalizeText(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " y ")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const normalizeOccasionSlug = (value) => {
  const slug = slugifyValue(value);
  return OCCASION_ALIASES[slug] || slug;
};

const CATEGORY_VALUE_MAP = CATALOG_CATEGORY_OPTIONS.reduce((acc, category) => {
  acc[slugifyValue(category)] = category;
  return acc;
}, {});

const parseCsvParam = (value) =>
  normalizeText(value)
    .split(",")
    .map((item) => normalizeOccasionSlug(item))
    .filter(Boolean);

const parseTextCsvParam = (value) =>
  normalizeText(value)
    .split(",")
    .map((item) => normalizeText(item))
    .filter(Boolean);

const parseCategoryCsvParam = (value) =>
  parseTextCsvParam(value)
    .map((item) => slugifyValue(item))
    .map((categorySlug) => CATEGORY_VALUE_MAP[categorySlug])
    .filter(Boolean);

const getTimestamp = (value) => {
  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const getClicksCount = (value) => {
  const clicksCount = Number(value);
  return Number.isFinite(clicksCount) ? clicksCount : 0;
};

const getSafeCount = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) && parsedValue >= 0 ? parsedValue : 0;
};

const getRandomRank = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 1;
};

const buildHandleHref = (value, platformBaseUrl, hostMatcher) => {
  const rawValue = normalizeText(value);

  if (!rawValue) {
    return "";
  }

  if (/^https?:\/\//i.test(rawValue)) {
    return rawValue;
  }

  const normalizedValue = rawValue
    .replace(/^@+/, "")
    .replace(hostMatcher, "")
    .replace(/^\/+/, "")
    .split(/[/?#]/)[0]
    .trim();

  if (!normalizedValue) {
    return "";
  }

  return `${platformBaseUrl}${normalizedValue}`;
};

const mapPostulationToEntrepreneur = (postulation) => {
  const photos = normalizeArray(postulation?.galleryImagePreviewUrls).length
    ? normalizeArray(postulation?.galleryImagePreviewUrls)
    : normalizeArray(postulation?.galleryImages);

  return {
    id: firstNonEmptyValue(postulation?.id, postulation?.user),
    visible: true,
    showMore: false,
    logo: firstNonEmptyValue(
      postulation?.logoImagePreviewUrl,
      postulation?.logoImage
    ),
    photos,
    business_name:
      firstNonEmptyValue(
        postulation?.companyName,
        postulation?.businessName,
        postulation?.name
      ) || "Emprendimiento",
    category: firstNonEmptyValue(postulation?.category) || "Sin categoría",
    region: firstNonEmptyValue(postulation?.region, postulation?.userRegion),
    featuredContexts: normalizeArray(postulation?.featuredContexts),
    clicks: getClicksCount(postulation?.clicks),
    createdAt: firstNonEmptyValue(postulation?.createdAt, postulation?.updatedAt),
    description:
      firstNonEmptyValue(
        postulation?.companyDescription,
        postulation?.description
      ) || DEFAULT_DESCRIPTION,
    web: firstNonEmptyValue(postulation?.website, postulation?.companyWebsite),
    email: firstNonEmptyValue(
      postulation?.companyEmail,
      postulation?.userEmail
    ),
    phone: firstNonEmptyValue(
      postulation?.companyTelephone,
      postulation?.userCelphone
    ),
    instagram: firstNonEmptyValue(
      postulation?.instagram,
      postulation?.companyInstagram
    ),
    facebook: firstNonEmptyValue(
      postulation?.facebook,
      postulation?.companyFacebook
    ),
    ownerName: firstNonEmptyValue(postulation?.userName),
    commercialOffer: firstNonEmptyValue(postulation?.commercialOffer),
  };
};

const CATALOG_ENDPOINT_URL = CATALOG_POSTULATIONS_URL || CATALOG_POSTULATIONS_PATH;
const CATALOG_OCCASIONS_ENDPOINT_URL =
  CATALOG_OCCASIONS_URL || CATALOG_OCCASIONS_PATH;
const REGISTER_CLICK_ENDPOINT_SUFFIX = "/api/catalog-postulations";

export default {
  name: "ArticulosEmpred",
  props: {
    maxItems: {
      type: Number,
      default: 0,
    },
    featuredOccasion: {
      type: String,
      default: "",
    },
    suppressCatalogEvents: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isFeaturedList() {
      return this.maxItems > 0;
    },
    featuredOccasionSlug() {
      return this.isFeaturedList
        ? normalizeOccasionSlug(this.featuredOccasion)
        : "";
    },
  },
  data: () => ({
    emprendedores: [],
    allEntrepreneurs: [],
    catalogOccasions: [],
    page: 1,
    limit: 10,
    filtros: [],
    activeOccasions: [],
    activeRegions: [],
    searchQuery: "",
    selectedImage: null,
    dialog: false,
    loading: false,
    snackbarMessage: "",
    profileDialog: false,
    selectedEntrepreneur: null,
    currentProfileSlug: "",
    profileParamKey: "profile",
    suppressWatcherCleanup: false,
  }),

  created() {
    this.fetchCatalogOccasions();
    this.fetchEntrepreneurs();
    EventBus.$on("filtrosCategoria", this.handleCategoryFilters);
    EventBus.$on("catalogFiltersChanged", this.handleCatalogFiltersChanged);
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("popstate", this.handlePopState);
    this.syncProfileFromUrl();
  },
  methods: {
    handleCategoryFilters(filtro) {
      this.filtros = Array.isArray(filtro) ? filtro : [];
      this.resetPagination();
    },
    handleCatalogFiltersChanged(payload) {
      this.activeOccasions = Array.isArray(payload?.occasions)
        ? payload.occasions
        : [];
      this.activeRegions = Array.isArray(payload?.regions)
        ? payload.regions
        : [];
      this.searchQuery = normalizeText(payload?.query);
      this.filtros = Array.isArray(payload?.categories)
        ? payload.categories
        : [];
      this.resetPagination();
    },
    async fetchEntrepreneurs() {
      this.showSnackbar("Cargando emprendimientos...");
      try {
        const response = await fetch(CATALOG_ENDPOINT_URL);
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
        const payload = await response.json();
        const rawList = Array.isArray(payload.postulations)
          ? payload.postulations
          : [];
        const sortedRawList = [...rawList].sort((left, right) => {
          return (
            getTimestamp(right?.createdAt) - getTimestamp(left?.createdAt)
          );
        });
        const slugRegistry = new Set();
        this.allEntrepreneurs = sortedRawList
          .filter((item) => !!item)
          .map((item, index) => {
            const mappedEntrepreneur = mapPostulationToEntrepreneur(item);

            return {
              ...mappedEntrepreneur,
              featuredRandomRank: Math.random(),
              profileSlug: this.createProfileSlug(
                mappedEntrepreneur,
                index,
                slugRegistry
              ),
            };
          });
        if (!this.suppressCatalogEvents) {
          this.emitCatalogRegions();
        }
        this.syncCatalogFiltersFromUrl();
        this.resetPagination();
        this.hideSnackbar();
        this.syncProfileFromUrl();
      } catch (error) {
        console.error("Error fetching entrepreneurs", error);
        if (!this.suppressCatalogEvents) {
          this.emitCatalogRegions([]);
          this.emitCatalogMetrics([]);
        }
        this.showSnackbar("No se pudieron cargar los emprendimientos.");
      }
    },
    async fetchCatalogOccasions() {
      if (this.suppressCatalogEvents) {
        return;
      }

      try {
        const response = await fetch(CATALOG_OCCASIONS_ENDPOINT_URL);

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const payload = await response.json();
        this.catalogOccasions = Array.isArray(payload?.occasions)
          ? payload.occasions
          : [];
        this.emitCatalogOccasions();
      } catch (error) {
        console.error("Error fetching catalog occasions", error);
        this.catalogOccasions = [];
        this.emitCatalogOccasions([]);
      }
    },
    resetPagination() {
      this.page = 1;
      this.emprendedores = [];
      const filteredEntrepreneurs = this.getFilteredEntrepreneurs();
      if (!this.suppressCatalogEvents) {
        this.emitCatalogMetrics(filteredEntrepreneurs);
      }
      this.loadMoreEmprendedores(filteredEntrepreneurs);
    },
    loadMoreEmprendedores(filteredEntrepreneurs = null) {
      const source = Array.isArray(filteredEntrepreneurs)
        ? filteredEntrepreneurs
        : this.getFilteredEntrepreneurs();

      if (!source.length) {
        return;
      }
      const paginatedSource =
        this.maxItems > 0 ? source.slice(0, this.maxItems) : source;

      const start = (this.page - 1) * this.limit;
      const end = start + this.limit;

      const newEmprendedores = paginatedSource.slice(start, end);
      if (!newEmprendedores.length) {
        return;
      }

      this.emprendedores = [...this.emprendedores, ...newEmprendedores];
      this.page++;
    },
    handleScroll() {
      if (this.maxItems > 0) {
        return;
      }

      if (!this.$refs.endOfPage) {
        return;
      }
      const endOfPage = this.$refs.endOfPage.offsetTop;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      if (scrollTop + windowHeight >= endOfPage) {
        this.loadMoreEmprendedores();
      }
    },

    zoom(imagePath) {
      this.selectedImage = imagePath;
      this.dialog = true;
    },
    trackEvent(eventName, params) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
    },
    trackEmprendedorClick(emprendedor) {
      this.trackEvent('ver_perfil_emprendedor', {
        emprendedor_id: emprendedor.id,
        emprendedor_nombre: emprendedor.business_name,
        emprendedor_categoria: emprendedor.category,
      });
    },
    trackContactClick(emprendedor, contactType) {
      this.trackEvent('click_contacto', {
        emprendedor_id: emprendedor.id,
        emprendedor_nombre: emprendedor.business_name,
        emprendedor_categoria: emprendedor.category,
        tipo_contacto: contactType,
      });
    },
    trackPageView(path, title) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: path,
          page_location: window.location.origin + path,
          page_title: title || document.title,
        });
      }
    },
    openProfile(emprendedor, options = {}) {
      if (!emprendedor) {
        return;
      }
      this.selectedEntrepreneur = emprendedor;
      this.profileDialog = true;
      const slug = emprendedor.profileSlug || "";
      if (options.trackClick !== false) {
        this.registerPostulationClick(emprendedor);
        this.trackEmprendedorClick(emprendedor);
      }
      if (options.skipUrlUpdate) {
        this.currentProfileSlug = slug;
        this.trackPageView(
          `${window.location.pathname}?profile=${slug}`,
          emprendedor.name || emprendedor.businessName || slug,
        );
        return;
      }
      this.updateUrlWithProfile(slug);
      this.trackPageView(
        `${window.location.pathname}?profile=${slug}`,
        emprendedor.name || emprendedor.businessName || slug,
      );
    },
    closeProfile(options = {}) {
      this.suppressWatcherCleanup = true;
      this.profileDialog = false;
      this.selectedEntrepreneur = null;
      if (options.skipUrlUpdate) {
        this.currentProfileSlug = "";
      } else {
        this.clearProfileFromUrl();
      }
      this.trackPageView(window.location.pathname + window.location.search, document.title);
      this.$nextTick(() => {
        this.suppressWatcherCleanup = false;
      });
    },
    getVisibleEntrepreneurs() {
      if (!this.allEntrepreneurs.length) {
        return [];
      }

      return this.allEntrepreneurs.filter((x) => x.visible === true);
    },
    matchesBaseCatalogFilters(entrepreneur) {
      const category = normalizeText(entrepreneur.category);
      const matchesCategory = !this.filtros.length || this.filtros.some((filt) => {
        if (filt === "Otros") {
          return !STANDARD_CATEGORIES.includes(category);
        }
        return category === filt;
      });
      const entrepreneurRegion = slugifyValue(entrepreneur.region);
      const matchesRegion = !this.activeRegions.length || this.activeRegions.some(
        (region) => slugifyValue(region) === entrepreneurRegion
      );
      const entrepreneurOccasions = normalizeArray(
        entrepreneur.featuredContexts
      ).map((occasion) => normalizeOccasionSlug(occasion));
      const matchesOccasion =
        !this.activeOccasions.length ||
        this.activeOccasions.some((occasion) =>
          entrepreneurOccasions.includes(normalizeOccasionSlug(occasion))
        );

      return (
        matchesCategory &&
        matchesOccasion &&
        matchesRegion &&
        this.matchesCatalogQuery(entrepreneur)
      );
    },
    matchesFeaturedOccasion(entrepreneur) {
      if (!this.featuredOccasionSlug) {
        return true;
      }

      const entrepreneurOccasions = normalizeArray(
        entrepreneur.featuredContexts
      ).map((occasion) => normalizeOccasionSlug(occasion));

      return entrepreneurOccasions.includes(this.featuredOccasionSlug);
    },
    getFeaturedEntrepreneurs(visibleEntrepreneurs) {
      const maxItems = Number(this.maxItems);
      const featuredLimit =
        Number.isFinite(maxItems) && maxItems > 0 ? maxItems : 0;
      const eligibleEntrepreneurs = visibleEntrepreneurs.filter((entrepreneur) =>
        this.matchesBaseCatalogFilters(entrepreneur)
      );
      const occasionEntrepreneurs = eligibleEntrepreneurs
        .filter((entrepreneur) => this.matchesFeaturedOccasion(entrepreneur))
        .sort(
          (left, right) =>
            getRandomRank(left.featuredRandomRank) -
            getRandomRank(right.featuredRandomRank)
        );

      if (!featuredLimit) {
        return occasionEntrepreneurs;
      }

      if (occasionEntrepreneurs.length >= featuredLimit) {
        return occasionEntrepreneurs.slice(0, featuredLimit);
      }

      const fallbackEntrepreneurs = eligibleEntrepreneurs
        .filter((entrepreneur) => !occasionEntrepreneurs.includes(entrepreneur))
        .sort(
          (left, right) =>
            getRandomRank(left.featuredRandomRank) -
            getRandomRank(right.featuredRandomRank)
        );

      return [...occasionEntrepreneurs, ...fallbackEntrepreneurs].slice(
        0,
        featuredLimit
      );
    },
    getFilteredEntrepreneurs() {
      const visibleEntrepreneurs = this.getVisibleEntrepreneurs();

      if (this.isFeaturedList) {
        return this.getFeaturedEntrepreneurs(visibleEntrepreneurs);
      }

      return visibleEntrepreneurs
        .filter((entrepreneur) => this.matchesBaseCatalogFilters(entrepreneur))
        .sort(
          (left, right) =>
            getTimestamp(right.createdAt) - getTimestamp(left.createdAt)
        );
    },
    emitCatalogRegions(regions = null) {
      const visibleEntrepreneurs = this.getVisibleEntrepreneurs();
      const nextRegions = Array.isArray(regions)
        ? regions
        : [...new Set(
          visibleEntrepreneurs
            .map((entrepreneur) => normalizeText(entrepreneur.region))
            .filter(Boolean)
        )].sort((left, right) => left.localeCompare(right, "es-CL"));

      EventBus.$emit("catalogRegionsUpdated", nextRegions);
    },
    emitCatalogOccasions(occasions = null) {
      const rawOccasions = Array.isArray(occasions)
        ? occasions
        : this.catalogOccasions;
      const occasionItems = rawOccasions.reduce((items, occasion) => {
        const label = normalizeText(
          typeof occasion === "string" ? occasion : occasion?.name
        );
        const emoji = normalizeText(
          typeof occasion === "string" ? "" : occasion?.emoji
        );
        const value = normalizeOccasionSlug(label);

        if (!label || !value || items.some((item) => item.value === value)) {
          return items;
        }

        return [
          ...items,
          {
            label,
            value,
            emoji,
          },
        ];
      }, []);

      EventBus.$emit(
        "catalogOccasionsUpdated",
        occasionItems.sort((left, right) =>
          left.label.localeCompare(right.label, "es-CL")
        )
      );
    },
    emitCatalogMetrics(filteredEntrepreneurs = null) {
      const visibleEntrepreneurs = this.getVisibleEntrepreneurs();
      const filteredResults = Array.isArray(filteredEntrepreneurs)
        ? filteredEntrepreneurs
        : this.getFilteredEntrepreneurs();

      EventBus.$emit("catalogMetricsUpdated", {
        totalCount: getSafeCount(visibleEntrepreneurs.length),
        filteredCount: getSafeCount(filteredResults.length),
      });
    },
    async registerPostulationClick(entrepreneur) {
      const postulationId = entrepreneur?.id;

      if (!postulationId) {
        return;
      }

      try {
        const endpointBase = CATALOG_ENDPOINT_URL
          ? CATALOG_ENDPOINT_URL.replace(/\/api\/catalog-postulations\/public\/?$/i, "")
          : "";
        const registerClickUrl = endpointBase
          ? `${endpointBase}${REGISTER_CLICK_ENDPOINT_SUFFIX}/${postulationId}/click`
          : `${REGISTER_CLICK_ENDPOINT_SUFFIX}/${postulationId}/click`;

        await fetch(registerClickUrl, {
          method: "POST",
        });
      } catch (error) {
        console.error("Error registering catalog postulation click", error);
      }
    },
    matchesCatalogQuery(entrepreneur) {
      if (!entrepreneur) {
        return false;
      }

      if (this.activeOccasions.length) {
        const entrepreneurOccasions = normalizeArray(
          entrepreneur.featuredContexts
        ).map((occasion) => normalizeOccasionSlug(occasion));

        const matchesOccasion = this.activeOccasions.some((occasion) =>
          entrepreneurOccasions.includes(occasion)
        );

        if (!matchesOccasion) {
          return false;
        }
      }

      const normalizedQuery = slugifyValue(this.searchQuery).replace(/_/g, " ");

      if (!normalizedQuery) {
        return true;
      }

      const searchableFields = [
        entrepreneur.business_name,
        entrepreneur.category,
        entrepreneur.description,
        entrepreneur.commercialOffer,
        entrepreneur.ownerName,
        entrepreneur.web,
        ...(Array.isArray(entrepreneur.featuredContexts)
          ? entrepreneur.featuredContexts
          : []),
      ];

      const searchableText = searchableFields
        .map((field) => slugifyValue(field).replace(/_/g, " "))
        .filter(Boolean)
        .join(" ");

      return searchableText.includes(normalizedQuery);
    },
    resolveLogoSrc(logoPath) {
      if (!logoPath) {
        return "";
      }
      return this.ensureRelativeAsset(logoPath, "logos");
    },
    resolvePhotoSrc(photoPath) {
      if (!photoPath) {
        return "";
      }
      return this.ensureRelativeAsset(photoPath, "products");
    },
    showSnackbar(message) {
      this.snackbarMessage = message;
      this.loading = true;
    },
    hideSnackbar() {
      this.loading = false;
      this.snackbarMessage = "";
    },
    resolveWebsiteHref(value) {
      const rawValue = normalizeText(value);

      if (!rawValue) {
        return "";
      }

      if (/^https?:\/\//i.test(rawValue)) {
        return rawValue;
      }

      return `https://${rawValue.replace(/^\/+/, "")}`;
    },
    hasWebsite(value) {
      return this.resolveWebsiteHref(value) !== "";
    },
    resolveInstagramHref(value) {
      return buildHandleHref(
        value,
        "https://www.instagram.com/",
        /^(https?:\/\/)?(www\.)?instagram\.com\//i
      );
    },
    hasInstagram(value) {
      return this.resolveInstagramHref(value) !== "";
    },
    resolveFacebookHref(value) {
      return buildHandleHref(
        value,
        "https://www.facebook.com/",
        /^(https?:\/\/)?(www\.)?facebook\.com\//i
      );
    },
    hasFacebook(value) {
      return this.resolveFacebookHref(value) !== "";
    },
    resolveMailTo(email) {
      if (!this.hasEmail(email)) {
        return "";
      }
      return `mailto:${String(email).trim()}`;
    },
    hasEmail(email) {
      if (email === null || email === undefined) {
        return false;
      }
      return String(email).trim() !== "";
    },
    resolveWhatsApp(phone) {
      if (!this.hasPhone(phone)) {
        return "";
      }

      const normalizedPhone = String(phone).replace(/\D+/g, "");

      if (!normalizedPhone) {
        return "";
      }

      return `https://wa.me/${normalizedPhone}`;
    },
    hasPhone(phone) {
      if (phone === null || phone === undefined) {
        return false;
      }
      return String(phone).trim() !== "";
    },
    ensureRelativeAsset(pathValue, folder) {
      const raw = String(pathValue || "").trim();
      if (!raw) {
        return "";
      }
      if (/^https?:\/\//i.test(raw)) {
        return raw;
      }

      if (ASSET_BASE_URL) {
        const remotePath = raw.includes("/") ? raw : `${folder}/${raw}`;
        return `${ASSET_BASE_URL}${remotePath}`;
      }

      return `${process.env.BASE_URL || "/"}assets/img/pymes/${folder}/${raw}`;
    },
    createProfileSlug(item, index, registry) {
      const baseId = (item && item.id && String(item.id).trim()) || "";
      const baseName =
        (item && item.business_name && String(item.business_name).trim()) || "";
      const rawBase = baseId || baseName || `perfil-${index + 1}`;
      const normalized = rawBase
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
      const fallback = normalized || `perfil-${index + 1}`;
      let uniqueSlug = fallback;
      let suffix = 1;
      while (registry.has(uniqueSlug)) {
        uniqueSlug = `${fallback}-${suffix}`;
        suffix += 1;
      }
      registry.add(uniqueSlug);
      return uniqueSlug;
    },
    updateUrlWithProfile(slug) {
      if (typeof window === "undefined" || !slug) {
        return;
      }
      if (this.currentProfileSlug === slug) {
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.set(this.profileParamKey, slug);
      window.history.pushState({ profile: slug }, "", url.toString());
      this.currentProfileSlug = slug;
    },
    clearProfileFromUrl() {
      if (typeof window === "undefined") {
        this.currentProfileSlug = "";
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.delete(this.profileParamKey);
      window.history.replaceState({}, "", url.toString());
      this.currentProfileSlug = "";
    },
    getProfileSlugFromLocation() {
      if (typeof window === "undefined") {
        return "";
      }
      const url = new URL(window.location.href);
      const value = url.searchParams.get(this.profileParamKey);
      return value ? value.trim() : "";
    },
    syncCatalogFiltersFromUrl() {
      if (typeof window === "undefined") {
        this.activeOccasions = [];
        this.activeRegions = [];
        this.searchQuery = "";
        this.filtros = [];
        return;
      }

      const url = new URL(window.location.href);
      this.activeOccasions = parseCsvParam(
        url.searchParams.get(SEARCH_PARAM_OCCASION)
      );
      this.searchQuery = normalizeText(
        url.searchParams.get(SEARCH_PARAM_QUERY)
      );
      this.activeRegions = parseTextCsvParam(
        url.searchParams.get(SEARCH_PARAM_REGION)
      );
      this.filtros = parseCategoryCsvParam(
        url.searchParams.get(SEARCH_PARAM_CATEGORY)
      );
    },
    findEntrepreneurBySlug(slug) {
      if (!slug || !Array.isArray(this.allEntrepreneurs)) {
        return null;
      }
      return (
        this.allEntrepreneurs.find(
          (entrepreneur) => entrepreneur.profileSlug === slug
        ) || null
      );
    },
    syncProfileFromUrl() {
      const slug = this.getProfileSlugFromLocation();
      if (!slug || !this.allEntrepreneurs.length) {
        return;
      }
      if (this.profileDialog && this.currentProfileSlug === slug) {
        return;
      }
      const entrepreneur = this.findEntrepreneurBySlug(slug);
      if (entrepreneur) {
        this.openProfile(entrepreneur, {
          skipUrlUpdate: true,
          trackClick: false,
        });
      }
    },
    handlePopState() {
      this.syncCatalogFiltersFromUrl();
      this.resetPagination();

      const slug = this.getProfileSlugFromLocation();
      if (slug) {
        const entrepreneur = this.findEntrepreneurBySlug(slug);
        if (entrepreneur) {
          this.openProfile(entrepreneur, {
            skipUrlUpdate: true,
            trackClick: false,
          });
        }
        return;
      }
      if (this.profileDialog) {
        this.closeProfile({ skipUrlUpdate: true });
      }
    },
  },

  beforeDestroy() {
    EventBus.$off("filtrosCategoria", this.handleCategoryFilters);
    EventBus.$off("catalogFiltersChanged", this.handleCatalogFiltersChanged);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("popstate", this.handlePopState);
  },
  watch: {
    featuredOccasion() {
      this.resetPagination();
    },
    maxItems() {
      this.resetPagination();
    },
    profileDialog(value) {
      if (!value) {
        if (!this.suppressWatcherCleanup) {
          this.clearProfileFromUrl();
        }
        this.selectedEntrepreneur = null;
      }
    },
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@600&family=Montserrat:wght@500&display=swap');

.custom-title {
  font-family: 'Barlow', sans-serif;
  font-size: x-large;

}

.custom-subtitle {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
}

.custom-description {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
}

.entrepreneur-card {
  width: 100%;
  height: 100%;
}

.entrepreneur-card__body {
  width: 100%;
}

.entrepreneur-card__badge {
  margin-bottom: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, #ff8d43 0%, #ff5f2c 100%);
  box-shadow: 0 12px 24px rgba(255, 114, 53, 0.2);
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.entrepreneur-card--clickable {
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.entrepreneur-card--clickable:hover {
  transform: translateY(-4px);
  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.15);
}

.product-carousel {
  width: calc(100% - 32px);
  border-radius: 16px;
  overflow: hidden;
  margin: 0 auto 16px;
}

.product-carousel--dialog {
  width: 100%;
  margin: 0;
}

.entrepreneur-card__occasions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: calc(100% - 32px);
  margin: -4px auto 12px;
}

.entrepreneur-card__occasion-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 6px 12px;
  border-radius: 999px;
  background: linear-gradient(135deg, #fff1e6 0%, #ffe1cc 100%);
  border: 1px solid rgba(255, 122, 47, 0.16);
  color: #b6531b;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.product-carousel__image {
  object-fit: cover;
  cursor: pointer;
}

.product-carousel .v-btn--icon.v-size--default {
  height: 36px;
  width: 36px;
}

.product-carousel .v-btn--icon .v-icon {
  font-size: 12px;
}

.profile-dialog {
  border-radius: 20px;
}

.profile-dialog__close-btn {
  background-color: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.08);
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-dialog__close-icon {
  font-size: 20px;
  color: #1f1f1f;
}

.profile-dialog__title {
  font-family: 'Barlow', sans-serif;
  font-size: 24px;
  font-weight: 600;
}

.profile-dialog__subtitle {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  color: #777;
}

.profile-dialog__description {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  line-height: 1.5;
}

.profile-dialog__owner,
.profile-dialog__offer {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #444;
  margin-bottom: 12px;
}

.profile-dialog__contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
}

.profile-dialog__contact-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
}

.profile-dialog__contact-actions .v-btn {
  margin-right: 8px;
}

.profile-dialog__carousel {
  border-radius: 16px;
  overflow: hidden;
}

.product-carousel--dialog .v-image {
  border-radius: 0;
}

.profile-dialog__image {
  object-fit: cover;
}

.profile-dialog__empty {
  padding: 40px;
  text-align: center;
  color: #999;
  font-style: italic;
  border: 1px dashed #ccc;
  border-radius: 12px;
}
</style>
